"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styleUtilities_1 = require("../../util/styleUtilities");
var fontFamily = '"Noto Sans", "Helvetica", "Arial", sans-serif';
var bodyFontLineHeight = 20;
var unusedFont = {
    fontSize: '12px',
};
var fonts = {
    headline1: {
        fontWeight: 'bold',
        fontSize: (0, styleUtilities_1.pxToRem)(24),
        letterSpacing: 0,
        lineHeight: (0, styleUtilities_1.pxToRem)(32),
    },
    headline2: {
        fontWeight: 'bold',
        fontSize: (0, styleUtilities_1.pxToRem)(12),
        letterSpacing: (0, styleUtilities_1.pxToRem)(1.5),
        lineHeight: (0, styleUtilities_1.pxToRem)(16),
        textTransform: 'uppercase',
    },
    headline3: {
        fontWeight: 'bold',
        fontSize: (0, styleUtilities_1.pxToRem)(12),
        letterSpacing: (0, styleUtilities_1.pxToRem)(0.3),
        lineHeight: (0, styleUtilities_1.pxToRem)(16),
        whiteSpace: 'pre-line',
    },
    body: {
        fontWeight: 'normal',
        fontSize: (0, styleUtilities_1.pxToRem)(12),
        letterSpacing: (0, styleUtilities_1.pxToRem)(0.3),
        lineHeight: (0, styleUtilities_1.pxToRem)(bodyFontLineHeight),
    },
    label1: {
        fontWeight: 'normal',
        fontSize: (0, styleUtilities_1.pxToRem)(10),
        letterSpacing: (0, styleUtilities_1.pxToRem)(0.08),
        lineHeight: (0, styleUtilities_1.pxToRem)(14),
    },
    label2: {
        fontWeight: 'normal',
        fontSize: (0, styleUtilities_1.pxToRem)(10),
        letterSpacing: (0, styleUtilities_1.pxToRem)(0.3),
        lineHeight: (0, styleUtilities_1.pxToRem)(14),
        textTransform: 'uppercase',
    },
    button: {
        fontWeight: 'bold',
        fontSize: (0, styleUtilities_1.pxToRem)(10),
        letterSpacing: (0, styleUtilities_1.pxToRem)(0.08),
        lineHeight: (0, styleUtilities_1.pxToRem)(14),
    },
    body2: {
        fontWeight: 'bold',
        fontSize: (0, styleUtilities_1.pxToRem)(16),
        letterSpacing: (0, styleUtilities_1.pxToRem)(0.3),
        lineHeight: (0, styleUtilities_1.pxToRem)(24),
    },
};
var typography = {
    fontFamily: fontFamily,
    bodyFontLineHeight: bodyFontLineHeight,
    fonts: fonts,
    unusedFont: unusedFont,
};
exports.default = typography;
